import { render, staticRenderFns } from "./WorkflowFormAssigneePicker.vue?vue&type=template&id=ccfabc8a&"
import script from "./WorkflowFormAssigneePicker.vue?vue&type=script&lang=ts&"
export * from "./WorkflowFormAssigneePicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports